import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import Panel from "@/shared/components/Panel";
import { ResponsiveContainer } from 'recharts';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import ReactTableBase from '@/shared/components/table/ReactTableBase';

const APIUsagesByLayerList = () => {
    const [APIUsagesList, setAPIUsagesList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: false,
        withSearchEngine: true,
    };

    const GetAPIUsagesData = () => {
        AdminInterface.instance.getServiceUsageByLayer().then((response) => {
            const columns = [
                {
                    accessor: 'mission',
                    Header: 'Mission',
                },
                {
                    accessor: 'count',
                    Header: 'Count',
                    disableGlobalFilter: true,
                }
            ];
            const data = [];
            for (let layer in response.data) {
                data.push({
                    mission: layer,
                    count: response.data[layer]
                });
            }

            const APIUsagesListTableData = { tableHeaderData: columns, tableRowsData: data };
            setAPIUsagesList(APIUsagesListTableData);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        })
    };

    useEffect(() => {
        GetAPIUsagesData();
    }, []);

    return (
        <Panel lg={12} xl={12} md={12} title='API Usages By Layer' refreshRequest={() => GetAPIUsagesData()}>
            {APIUsagesList && <ResponsiveContainer>
                <ReactTableBase
                    columns={APIUsagesList.tableHeaderData}
                    data={APIUsagesList.tableRowsData}
                    tableConfig={tableConfig}
                />
            </ResponsiveContainer>}
        </Panel>
    );
};

APIUsagesByLayerList.propTypes = {
    APIUsagesListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default APIUsagesByLayerList;
